import { UrlConstants } from "../url.constants";
export class ApiTimeoutConstants {
    static URL = UrlConstants.API_V2 + "Timeout";
    static FUNCTION_GET_STOP_TIMEOUT_TIMERS = "GetStopTimeoutTimers";
    static FUNCTION_GET_AWAIT_TIMEOUT_TIMERS = "GetAwaitTimers";
    static FUNCTION_GET_DISTINCT_TIMEOUT_STATUS = "GetDistinctTimeoutStatus";
}
